/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Text } from "@nordcloud/gnui";
import { ApprovalMode, ExecutionPolicy } from "~/generated/graphql";
import { DataDisplayWrapper } from "~/components";
import { getApprovalModeLabel } from "~/constants/approvalMode";

type Props = {
  policy?: ExecutionPolicy;
  approvalMode?: ApprovalMode | null;
};

export function DisplayExecutionPolicy({ policy, approvalMode }: Props) {
  return (
    <>
      <Text size="sm" tag="div">
        Execution Policy
      </Text>
      <DataDisplayWrapper hasData={policy != null}>
        <Text data-testid={"label-action-execution-policy"}>
          {mapExecutionPolicy(policy, approvalMode)}
        </Text>
      </DataDisplayWrapper>
    </>
  );
}

const mapExecutionPolicy = (
  policy: ExecutionPolicy | undefined,
  approvalMode?: ApprovalMode | null
) => {
  switch (policy) {
    case ExecutionPolicy.Approval:
      return approvalMode
        ? `Approval Required (${getApprovalModeLabel(approvalMode)})`
        : "Approval Required";
    case ExecutionPolicy.Anyway:
      return "Run Anyway";
    case ExecutionPolicy.SuccessOrApproval:
      return "Success or Approval";
    default:
      return "N/A";
  }
};
